import type { ContentCardData } from "../../../@types/portalAluno";
import type { HistoryApiItem } from "../../../@types/portalAluno";
import { asBoolean, asObject, asText } from "../coerce";
import { mapApiItemToCard } from "./contentCardMapper";

const asIsoDate = (value: unknown) => {
  const text = asText(value);
  if (!text) return undefined;
  const date = new Date(text);

  return Number.isNaN(date.getTime()) ? undefined : date.toISOString();
};

export const mapHistoryResponse = (value: unknown): ContentCardData[] => {
  if (!Array.isArray(value)) {
    throw new Error("A API retornou um histórico inválido.");
  }

  return value.reduce<ContentCardData[]>((cards, rawItem) => {
    const item = asObject<HistoryApiItem>(rawItem);
    if (!item || !asBoolean(item.isAtivo)) return cards;

    const card = mapApiItemToCard(item, "conteudos");
    if (!card) return cards;

    cards.push({
      ...card,
      accessedAt: asIsoDate(item.dtRealizado),
      completed: true,
    });
    return cards;
  }, []);
};
